import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const SchoolTeamProfileSecondaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] sm:w-auto",
})``;

export const SchoolTeamProfilePrimaryButton = styled.button.attrs({
  className:
    "inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)] sm:w-auto",
})``;

export const SchoolTeamProfileGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const SchoolTeamProfileOverviewStack = styled.div.attrs({
  className: "grid gap-6",
})``;

export const SchoolTeamProfileSection = styled.div.attrs({ className: "mt-8" })``;

export const SchoolTeamProfileContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const SchoolTeamProfileHeroRow = styled.div.attrs({
  className: "flex items-center gap-4",
})``;

export const SchoolTeamProfileHeroImage = styled(FallbackImage).attrs({
  className:
    "h-16 w-16 shrink-0 rounded-[22px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_12px_20px_rgba(0,0,0,0.18)] sm:h-20 sm:w-20",
})``;

export const SchoolTeamProfileHeroTextGroup = styled.div.attrs({ className: "min-w-0 flex-1" })``;

export const SchoolTeamProfileHeroEyebrow = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const SchoolTeamProfileHeroTitle = styled.h3.attrs({
  className: "mt-2 text-xl font-semibold text-[var(--brand-ink)] sm:text-2xl",
})``;

export const SchoolTeamProfileHeroMeta = styled.p.attrs({
  className: "mt-1 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const SchoolTeamProfileBadgeRow = styled.div.attrs({
  className: "mt-3 flex flex-wrap items-center gap-2",
})``;

export const SchoolTeamProfileMetadataGrid = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-2 xl:grid-cols-3",
})``;

export const SchoolTeamProfileMetadataTile = styled.div.attrs({
  className: "brand-panel-muted rounded-[18px] px-4 py-3.5",
})``;

export const SchoolTeamProfilePreviewImage = styled(FallbackImage).attrs({
  className: "mx-auto h-32 w-32 max-w-full rounded-[22px] sm:h-44 sm:w-44 sm:rounded-[24px]",
})``;

export const SchoolTeamProfileGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const SchoolTeamProfileSectionSecondary = styled.div.attrs({
  className: "brand-panel-muted",
})``;

export const SchoolTeamProfileEyebrowText = styled.p.attrs({
  className: "text-[11px] uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const SchoolTeamProfileTitleText = styled.p.attrs({
  className: "mt-1.5 text-base font-medium leading-snug text-[var(--brand-ink)]",
})``;

export const SchoolTeamProfileGridLayoutQuaternary = styled.div.attrs({
  className: "grid gap-4",
})``;

export const SchoolTeamProfileMetaText = styled.p.attrs({
  className: "mt-1 text-sm text-[var(--brand-muted)]",
})``;

export const SchoolTeamProfileSectionTertiary = styled.div.attrs({
  className: "flex flex-wrap gap-2",
})``;

export const SchoolTeamProfileActionLink = styled.a.attrs({
  className:
    "inline-flex items-center gap-2 rounded-full border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-2 text-sm font-medium text-[var(--brand-highlight)] transition hover:border-[var(--brand-highlight)]/60 hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const SchoolTeamProfileGridLayoutQuinary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[1.05fr_0.95fr]",
})``;

export const SchoolTeamProfileInfoRow = styled.div.attrs({
  className: "flex items-center gap-3",
})``;

export const SchoolTeamProfileThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const SchoolTeamProfileLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SchoolTeamProfileMetaTextSecondary = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const SchoolTeamProfileGridLayoutSenary = styled.div.attrs({ className: "grid gap-5" })``;

export const SchoolTeamProfileContentStackSecondary = styled.div.attrs({
  className: "space-y-6",
})``;

export const SchoolTeamProfileGridLayoutSeptenary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.95fr_1.05fr]",
})``;

